export const ROUTES = {
  home: '/',
  admin: {
    root: '/admin',
    epp: '/admin/epp',
    users: '/admin/users',
    domains: '/admin/domains',
    subscriptions: '/admin/subscriptions',
  },
  whois: '/whois',
  ai: '/ai',
  hosting: {
    static: '/hosting/static',
  },
  domains: {
    search: '/domains',
    transfer: '/domains/transfer',
    prices: '/domains/prices',
  },
  account: {
    profile: '/account',
    domains: '/account/domains',
    domain: '/account/domains/:domain',
    orders: '/account/orders',
    order: '/account/orders/:orderId',
    websites: '/account/websites',
    website: '/account/websites/:websiteId',
    websiteDeployments: '/account/websites/:websiteId/deployments',
    websiteDeployment: '/account/websites/:websiteId/deployments/:deploymentId',
    websiteDomains: '/account/websites/:websiteId/domains',
    websiteEditor: '/account/websites/:websiteId/editor',
    websiteAnalytics: '/account/websites/:websiteId/analytics',
    websiteSettings: '/account/websites/:websiteId/settings',
  },
  checkout: {
    cart: '/checkout/cart',
    contact: '/checkout/contact',
    payment: '/checkout/payment',
    summary: '/checkout/summary',
    amountsDue: '/checkout/amounts-due',
    order: '/checkout/order/:orderId',
    result: '/checkout/result',
  },
  auth: {
    root: '/auth',
    signin: '/auth/signin',
    signup: '/auth/signup',
    verify: '/auth/verify',
    callback: '/auth/callback',
    reset: '/auth/reset',
    action: '/auth/action',
  },
  legal: {
    privacyPolicy: '/legal/privacy-policy',
    terms: '/legal/terms-of-service',
    dra: '/legal/domain-registration-agreement',
    dpa: '/legal/data-processing-agreement',
    websiteHostingAgreement: '/legal/website-hosting-agreement',
  },
};

type Prettify<T> = {
  [K in keyof T]: T[K];
} & {};

type NestedKeyOf<ObjectType extends object> = {
  [Key in keyof ObjectType & (string | number)]: ObjectType[Key] extends object ? `${Key}` | `${Key}.${NestedKeyOf<ObjectType[Key]>}` : `${Key}`;
}[keyof ObjectType & (string | number)];

export type IRoute = Prettify<NestedKeyOf<typeof ROUTES> | 'unknown'>;
